import { AbstractZone } from './abstract-zone';

export class NavZone extends AbstractZone<NavZone> {
  static readonly KEEP_IN_MODE = 'keep_in';
  static readonly KEEP_OUT_MODE = 'keep_out';
  static readonly SPEED_MODE = 'speed';

  mode: string;
  description: string;
  priority: number;
  speed_mps: number;

  deserialize(json: any): this {
    this.mode = json.mode;
    this.description = json.description;
    this.priority = json.priority;
    this.speed_mps = json.speed_mps;
    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      mode: this.mode,
      description: this.description,
      priority: this.priority,
      speed_mps: this.speed_mps,
    });
  }
}
